import { Box, Button, Chip, Drawer, IconButton } from "@mui/material";
import React, {
  useState,
  useCallback,
  useRef,
  useEffect,
  Fragment,
} from "react";
import axios from "axios";
import moment from "moment";
import { useHistory, useLocation, withRouter } from "react-router-dom";

export default function FavoriteStoreDrawer(props) {
  const history = useHistory();

  const { cd, favOpen, handleDrawerFavClose } = props;

  const [favoriteStoreDetail, setFavoriteStoreDetail] = useState([]);

  useEffect(() => {
    if (favOpen === true) loadDetail();
  }, [favOpen]);

  const loadDetail = () => {
    axios
      .get(`/api/sm/store/get/${cd}`)
      .then((res) => {
        setFavoriteStoreDetail(res.data.data.store);
        //   setFetching(false);
      })
      .catch((error) => {
        //   setFetching(false);
      });
  };

  return (
    <Drawer
      anchor="bottom"
      open={favOpen}
      onClose={handleDrawerFavClose}
      className="drawer-common-bottom size-small fav-drawer"
    >
      <div className="drawer-head">
        <h3>
          {favoriteStoreDetail.nm}
          {favoriteStoreDetail.hoursOfOperInfo == "영업종료" ? (
            <Chip label="영업종료" size="small" className="disableChip" />
          ) : favoriteStoreDetail.hoursOfOperInfo == "영업중" ? (
            <Chip label="영업중" color="primary" size="small" />
          ) : (
            <Chip label="휴무일" size="small" className="blackChip" />
          )}
        </h3>
        <IconButton
          aria-label="close"
          className="btn-close"
          onClick={handleDrawerFavClose}
        >
          <span className="hidden">닫기</span>
        </IconButton>
      </div>

      <div className="drawer-body">
        <table className="info-table">
          <tbody>
            <tr className="time">
              <th>영업 시간</th>
              <td>
                {favoriteStoreDetail.strtTm &&
                  moment()
                    .hours(favoriteStoreDetail.strtTm.substring(0, 2))
                    .minutes(favoriteStoreDetail.strtTm.substring(2, 2))
                    .format("HH:mm")}
                {" ~ "}
                {favoriteStoreDetail.tmTp == "1" ? "" : "익일 "}
                {favoriteStoreDetail.endTm &&
                  moment()
                    .hours(favoriteStoreDetail.endTm.substring(0, 2))
                    .minutes(favoriteStoreDetail.endTm.substring(2, 2))
                    .format("HH:mm")}
                <p className="info-txt">{favoriteStoreDetail.tmDesc}</p>
              </td>
            </tr>
            {favoriteStoreDetail.storeHolidayList && (
              <tr className="calendar">
                <th>휴무일</th>
                <td>
                  {favoriteStoreDetail.storeHolidayList.length > 0
                    ? favoriteStoreDetail.storeHolidayList.map(
                        (holyItem, i) => (
                          <Fragment key={i}>
                            {moment(holyItem.hldyYmd).format("MM.DD(ddd)")}
                            {favoriteStoreDetail.storeHolidayList.length ==
                            i + 1
                              ? ""
                              : ", "}
                          </Fragment>
                        )
                      )
                    : "연중무휴"}
                </td>
              </tr>
            )}
            <tr className="location">
              <th>주소</th>
              <td>{favoriteStoreDetail.addr}</td>
            </tr>
            {favoriteStoreDetail.tel && (
              <tr className="call">
                <th>대표전화</th>
                <td>
                  <a href={`tel:${favoriteStoreDetail.tel}`}>
                    {favoriteStoreDetail.tel}
                  </a>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <Button
          variant="outlined"
          color="primary"
          className="btn-rounded end-icon"
          size="small"
          endIcon={<i className="ico-go" />}
          onClick={() => {
            history.push(`/favorite-store`);
            handleDrawerFavClose();
          }}
        >
          다른 매장 찾기
        </Button>
      </div>
      <div className="drawer-foot">
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            history.push(`/favorite-store/detail/${cd}`);
            handleDrawerFavClose();
          }}
        >
          매장 상세정보
        </Button>
      </div>
    </Drawer>
  );
}
